import documente from "./documente.png";

export const DocumenteIcon = () => <img src={documente} alt="Documente icon" />;
